/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterConfirmDraftResponse,
  PresenterDraftFixedAssetResponse,
  PresenterError,
  PresenterIDResponse,
  PresenterPreFillDraftAssetRequest,
  PresenterPreFillDraftAssetResponse,
  PresenterResponse,
  PresenterUpsertDraftFixedAssetRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DraftAssets<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Reflects all 台帳未反映 drafts as registered fixed assets, runs depreciation, and transitions each draft status to 台帳反映済.
   *
   * @tags draft_assets
   * @name PostSuspenseAccountConfirm
   * @summary Confirm all draft assets (台帳反映・費用確定)
   * @request POST:/suspense_account/confirm
   */
  postSuspenseAccountConfirm = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterConfirmDraftResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/confirm`,
      method: "POST",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a staging draft from one or more AccPlus journal sides.
   *
   * @tags draft_assets
   * @name PostSuspenseAccountDraftAssets
   * @summary Create a new DraftFixedAsset
   * @request POST:/suspense_account/draft_assets
   */
  postSuspenseAccountDraftAssets = (
    body: PresenterUpsertDraftFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Given a list of (side_id, amount) allocations, returns server-computed
   *
   * @tags draft_assets
   * @name PostSuspenseAccountDraftAssetsPreFill
   * @summary Pre-fill basic info from journal sides
   * @request POST:/suspense_account/draft_assets/pre_fill
   */
  postSuspenseAccountDraftAssetsPreFill = (
    body: PresenterPreFillDraftAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterPreFillDraftAssetResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/pre_fill`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates Basic Info, ledgers, and the linked allocation set of an existing draft.
   *
   * @tags draft_assets
   * @name PutSuspenseAccountDraftAssetsById
   * @summary Update a DraftFixedAsset
   * @request PUT:/suspense_account/draft_assets/{id}
   */
  putSuspenseAccountDraftAssetsById = (
    id: number,
    body: PresenterUpsertDraftFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/${id}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Hard-deletes a NotReflected draft and reverts its journal-side allocated values.
   *
   * @tags draft_assets
   * @name DeleteSuspenseAccountDraftAssetsById
   * @summary Delete a DraftFixedAsset
   * @request DELETE:/suspense_account/draft_assets/{id}
   */
  deleteSuspenseAccountDraftAssetsById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/${id}`,
      method: "DELETE",
      ...params,
    });
}
